export default __webpack_public_path__ + "static/media/github.0ade81e0.svg";